import * as masterAction from "../slices/master.slice";
import { ENDPOINT } from "../../constants/server/api";
import { fetchApiData } from "../../utils/apiUtils";

export const getPrefixNames = (entityTypeCode) => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MASTER.PREFIX_NAME}/list`,
    params: { entity_type_code: entityTypeCode },
    dispatch,
    useAuth: false,
    dismissLoading: true,
  });
  if (data) {
    dispatch(masterAction.setPrefixNames(data));
  }
};

export const getShopProductCategories = () => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MASTER.SHOP_PRODUCT}/list`,
    dispatch,
    useAuth: false,
    dismissLoading: true,
  });
  if (data) {
    dispatch(masterAction.setShopProductCategories(data));
  }
};

export const getRestaurantTypes = () => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MASTER.RESTAURANT}/list`,
    dispatch,
    useAuth: false,
    dismissLoading: true,
  });
  if (data) {
    dispatch(masterAction.setRestaurantTypes(data));
  }
};

export const getEntityTypes = () => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MASTER.ENTITY}/list`,
    dispatch,
    useAuth: false,
    dismissLoading: true,
  });
  if (data) {
    dispatch(masterAction.setEntityTypes(data));
  }
};

export const getProvinces = () => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MASTER.PROVINCE}/list`,
    dispatch,
    useAuth: false,
    dismissLoading: true,
  });
  if (data) {
    dispatch(masterAction.setProvinces(data));
  }
};

export const getDistricts = (provinceId) => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MASTER.DISTRICT}/list`,
    params: { province_id: provinceId },
    dispatch,
    useAuth: false,
    dismissLoading: true,
  });
  if (data) {
    dispatch(masterAction.setDistricts(data));
  }
};

export const getSubDistricts = (districtId) => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MASTER.SUB_DISTRICT}/list`,
    params: { district_id: districtId },
    dispatch,
    useAuth: false,
    dismissLoading: true,
  });
  if (data) {
    dispatch(masterAction.setSubDistricts(data));
  }
};

export const getCurrencies = () => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MASTER.CURRENCY}/list`,
    dispatch,
    useAuth: false,
    dismissLoading: true,
  });
  if (data) {
    dispatch(masterAction.setCurrencies(data));
  }
};

export const getVatCalculations = () => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MASTER.VAT}/list`,
    dispatch,
    useAuth: false,
    dismissLoading: true,
  });
  if (data) {
    dispatch(masterAction.setVatCalculations(data));
  }
};

export const getCodeSettingDayList = () => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MASTER.CODE_SETTING_DAY}/list`,
    dispatch,
    useAuth: false,
    dismissLoading: true,
  });
  if (data) {
    dispatch(masterAction.setCodeSettingDays(data));
  }
};

export const getCodeSettingMonthList = () => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MASTER.CODE_SETTING_MONTH}/list`,
    dispatch,
    useAuth: false,
    dismissLoading: true,
  });
  if (data) {
    dispatch(masterAction.setCodeSettingMonths(data));
  }
};

export const getCodeSettingYearList = () => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MASTER.CODE_SETTING_YEAR}/list`,
    dispatch,
    useAuth: false,
    dismissLoading: true,
  });
  if (data) {
    dispatch(masterAction.setCodeSettingYears(data));
  }
};

export const getCounterSettingMaster = () => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MASTER.COUNTER_SETTING}/list`,
    dispatch,
    useAuth: false,
    dismissLoading: true,
  });
  if (data) {
    dispatch(masterAction.setCounterSettingMaster(data));
  }
};

export const getCountUnitTypes = () => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MASTER.COUNT_UNIT_TYPE}/list`,
    dispatch,
    useAuth: false,
    dismissLoading: true,
  });
  if (data) {
    dispatch(masterAction.setCountUnitTypes(data));
  }
};

export const getGenders = () => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MASTER.GENDER}/list`,
    dispatch,
    useAuth: false,
    dismissLoading: true,
  });
  if (data) {
    dispatch(masterAction.setGenders(data));
  }
};

export const getBusinessCustomerGroups = () => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MASTER.USER_BUSINESS_CUSTOMER_GROUP}/list`,
    dispatch,
    useAuth: false,
    dismissLoading: true,
  });
  if (data) {
    dispatch(masterAction.setBusinessCustomerGroups(data));
  }
};

export const getPackagePlanRenewals = () => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MASTER.PACKAGE_PLAN_RENEWAL}/list`,
    dispatch,
    useAuth: false,
    dismissLoading: true,
  });
  if (data) {
    dispatch(masterAction.setPackagePlanRenewals(data));
    return data;
  }
};

export const getPackageChangeResults = () => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MASTER.PACKAGE_CHANGE_RESULT}/list`,
    dispatch,
    useAuth: false,
    dismissLoading: true,
  });
  if (data) {
    dispatch(masterAction.setPackageChangeResults(data));
    return data;
  }
};

export const getPackageExpirations = () => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MASTER.PACKAGE_EXPIRATION}/list`,
    dispatch,
    useAuth: false,
    dismissLoading: true,
  });
  if (data) {
    dispatch(masterAction.setPackageExpirations(data));
    return data;
  }
};
